import React from 'react';

export default function CertificationManager() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Certification Manager</h1>
      {/* Certification management interface will be implemented here */}
    </div>
  );
}